// AttendanceCorrectionReportView

import { useState } from "react";
import { Reactable } from "../../components/ui/reactable";
import { ReportPageShell } from "../../components/ui/reportPageShell";
import { EMPLOYEE_ATTENDANCE_CORRECTION } from "../../constants/api";
import { EmployeeDetails } from "../../components/ui/cards";
import dayjs from "dayjs";

const AttendanceCorrectionReportView = () => {

    const [attendanceCorrectionReportView, setAttendanceCorrectionReportViewData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
        const AttendanceCorrectionReportViewColumns = [
        {
            accessor: "employee_name",
            Header: "Employee",
            sortable: true,
            fixed: true,
            filterable: true,
            maxWidth: "300px",
            Cell: ({ value, row }) => {
                const record = row;

                let empDetails = {
                    ...record?.employee,
                    designation_id: record?.employee?.designation
                        ? {
                            id: record?.employee.designation.id,
                            designation_name: record?.employee.designation.name,
                        }
                        : { id: 0, designation_name: "" },
                    first_name: record?.employee?.employee_name || "-",
                    id: record?.employee?.employee_id || "-",
                };

                return <EmployeeDetails details={empDetails} size="xs" />;
            },
        },
        {
            accessor: "actual_date",
            Header: "Date",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "actual_status",
            Header: "Attendance Status",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "actual_check_in",
            Header: "Check In",
            Cell: ({ value }) =>
                value && dayjs(value).isValid()
                    ? dayjs(value).format("h:mm A")
                    : "-",
        },
        {
            accessor: "actual_check_out",
            Header: "Check Out",
            Cell: ({ value }) =>
                value && dayjs(value).isValid()
                    ? dayjs(value).format("h:mm A")
                    : "-",
        },
        {
            accessor: "actual_break_hrs",
            Header: "Break Hrs",
            Cell: ({ value }) =>
                value && dayjs(value).isValid()
                    ? dayjs(value).format("HH:mm:ss")
                    : "-",
        },
        {
            accessor: "actual_overtime",
            Header: "Overtime",
            Cell: ({ value }) =>
                value && dayjs(value).isValid()
                    ? dayjs(value).format("HH:mm:ss")
                    : "-",
        },
        {
            accessor: "modified_date",
            Header: "Mod Date",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "modified_status",
            Header: "Mod Status",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "modified_check_in",
            Header: "Mod Check In",
            Cell: ({ value }) =>
                value && dayjs(value).isValid()
                    ? dayjs(value).format("h:mm A")
                    : "-",
        },
        {
            accessor: "modified_check_out",
            Header: "Mod Check Out",
            Cell: ({ value }) =>
                value && dayjs(value).isValid()
                    ? dayjs(value).format("h:mm A")
                    : "-",
        },
        {
            accessor: "modified_break_hrs",
            Header: "Mod Break Hrs",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "modified_overtime",
            Header: "Mod Overtime",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "modified_user",
            Header: "Corrected By",
            filterable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "correction_type",
            Header: "Type",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "reason",
            Header: "Reason",
            maxWidth: "280px",
            Cell: ({ value }) => (
                <span className="text-xs line-clamp-2" title={value || ""}>{value ?? "-"}</span>
            ),
        },
        {
            accessor: "source",
            Header: "Source",
            Cell: ({ value }) => value ?? "-",
        },
    ];

    return (
        <ReportPageShell title="Attendance Correction Report " count={totalRecords}>

            <Reactable
                columns={AttendanceCorrectionReportViewColumns}
                data={attendanceCorrectionReportView}
                setData={setAttendanceCorrectionReportViewData}
                setTotalCount={setTotalRecords}
                url={EMPLOYEE_ATTENDANCE_CORRECTION}
                serverSide={true}
                rowSize="sm"
                isCSVRequired={true}
                isPDFRequired={true}
                isFromToDateRequired={true}
            />
        </ReportPageShell>
    );
}

export default AttendanceCorrectionReportView;